// src/api/adminClient.js
// 관리자 전용 API 호출 — sessionStorage의 토큰을 자동으로 Authorization 헤더에 첨부합니다.

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
const TOKEN_KEY = 'hub_admin_token';

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  sessionStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  sessionStorage.removeItem(TOKEN_KEY);
}

export function isLoggedIn() {
  return !!getToken();
}

async function handleResponse(res) {
  const data = await res.json().catch(() => ({}));
  if (res.status === 401) {
    clearToken();
    // 토큰 만료/누락 시 로그인 페이지로 이동
    window.location.href = '/admin/login';
    throw new Error(data.error || '로그인이 필요합니다.');
  }
  if (!res.ok) {
    const msg = data.error || `요청 실패 (status: ${res.status})`;
    const detail = data.detail ? ` [${data.detail}]` : '';
    throw new Error(msg + detail);
  }
  return data;
}

function authHeaders(extra = {}) {
  const token = getToken();
  return token ? { ...extra, Authorization: `Bearer ${token}` } : extra;
}

export const adminApi = {
  login: (password) =>
    fetch(`${API_BASE}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
    }).then(async (res) => {
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || '로그인에 실패했습니다.');
      return data;
    }),

  get: (path) =>
    fetch(`${API_BASE}${path}`, { headers: authHeaders() }).then(handleResponse),

  post: (path, body) =>
    fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body),
    }).then(handleResponse),

  put: (path, body) =>
    fetch(`${API_BASE}${path}`, {
      method: 'PUT',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body),
    }).then(handleResponse),

  patch: (path, body) =>
    fetch(`${API_BASE}${path}`, {
      method: 'PATCH',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body),
    }).then(handleResponse),

  delete: (path) =>
    fetch(`${API_BASE}${path}`, { method: 'DELETE', headers: authHeaders() }).then(handleResponse),

  // 이력서 다운로드 등 직접 링크가 필요한 경우 토큰을 쿼리스트링으로 포함한 URL 생성
  fileUrl: (path) => `${API_BASE}${path}${path.includes('?') ? '&' : '?'}token=${getToken()}`,
};

export default adminApi;
